import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ClassicType} from "../../shared/models/ClassicType";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ServerPaginationService} from "../../shared/_services/server-pagination.service";
import {InterventiStoreService} from "../../Interventi/_services/interventi-store.service";
import {ApiRestService} from "../_services/api-rest.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ActivatedRoute, Router} from "@angular/router";
import {Permission} from "../../Login/_guards/Permission";
import {FiltriTicket} from "../Models/filtri-ticket";
import {Ticket} from "../Models/ticket";
import {TicketEditComponent} from "../ticket-edit/ticket-edit.component";

@Component({
  selector: 'app-ticket-list',
  templateUrl: './ticket-list.component.html'
})
export class TicketListComponent implements OnInit {
  collectionSize: number = 0;
  Stampe: any[];
  @Input() List: Ticket[];
  @Input() hasHeader: Boolean = true;
  @Input() hasFilter: Boolean = true;
  @Input() hasAddButton: Boolean = true;
  @Input() ModificheAbilitate: boolean = true;
  @Input() EditInModal: boolean=true;
  @Input() filtri: FiltriTicket = new FiltriTicket();
  @Output() AddClick = new EventEmitter();
  @Output() EditClick = new EventEmitter();
  @Output() DeleteClick = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Output() onRefresh = new EventEmitter();
  /**************************************
   Variabili paginazione
   **************************************/
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
  };
  statiselezionati: ClassicType[] = [];
  tipiselezionati: ClassicType[] = [];
  stati: ClassicType[] = [];
  tipi: ClassicType[] = [];
  constructor(
    private paginationService: ServerPaginationService,
    private InterventiStore: InterventiStoreService,
    private apirestservice: ApiRestService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    public permission: Permission
  ) {}

  ngOnInit() {
    this.refreshTable(1);
    this.apirestservice.getTipiTicket().subscribe(data=>{
      this.tipi = data;
    })
    this.apirestservice.getStatiTicket().subscribe(data=>{
      this.stati = data;
    })
  }
  add() {
    if (this.ModificheAbilitate) {
      this.OpenTicketForm();
      this.AddClick.emit();
    }
  }
  edit(item: Ticket) {
    if (this.ModificheAbilitate) {
      this.OpenTicketForm(item);
      this.EditClick.emit(item);
    }
  }
  delete(item: Ticket) {
    if (confirm("Sei socuro di voler eliminare questo elemento?"))
      this.apirestservice.deleteTicket(item).subscribe(()=> this.refreshTable(this.newpagegenerated));
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {
    this.filtri.page = (page - 1) / this.pagesizeserver + 1;
    this.filtri.size = this.pagesizeserver * this.pageSize;
    this.filtri.stato = this.getId(this.statiselezionati);
    this.filtri.tipo = this.getId(this.tipiselezionati);
    this.apirestservice.getTicket(this.filtri).subscribe(data=>{
      this.List = data.data;
      this.collectionSize = data.total;
      this.Stampe = data.stampe;
    })
    this.onRefresh.emit();
  }
  OpenTicketForm(ticket?: Ticket) {
    if (this.EditInModal) {
      const editmodal = this.modalService.open(TicketEditComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<TicketEditComponent>editmodal.componentInstance).onSave.subscribe(()=>this.refreshTable(1));
      if(ticket)
        (<TicketEditComponent>editmodal.componentInstance).ticket_id = ticket.id;
      else
        (<TicketEditComponent>editmodal.componentInstance).selected = new Ticket();
    } else {
      if(ticket)
        this.router.navigate([this.route.snapshot.queryParams[' ticket/edit/' + ticket.id.toString()] || 'ticket/edit/' + ticket.id.toString(),]);
      else
        this.router.navigate([this.route.snapshot.queryParams[' ticket/edit '] || 'ticket/edit',]);
    }
  }

  getId(array: any[]) {
    if(array && array[0] && array[0].id)
      return array[0].id;
    return null;
  }


}
